// trader_agent_frontend/src/components/PrivacyPolicy/PrivacyPolicy.jsx
import React from 'react';
import styles from './PrivacyPolicy.module.css';

const PrivacyPolicy = () => {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h1>Privacy Policy</h1>
          <p className={styles.lastUpdated}>Last Updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
          
          <section className={styles.section}>
            <h2>1. Information We Collect</h2>
            <p>We collect information you provide directly to us, such as when you create an account, use our services, or contact us for support.</p>
            <ul>
              <li><strong>Account Information:</strong> Name, email address, password, and profile information.</li>
              <li><strong>Trading Data:</strong> Backtest configurations, trading strategies, and performance metrics.</li>
              <li><strong>Usage Information:</strong> How you interact with our services, including log data and device information.</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>2. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide, maintain, and improve our services</li>
              <li>Process transactions and send related information</li>
              <li>Respond to your comments and questions</li>
              <li>Send technical notices and security alerts</li>
              <li>Personalize your experience</li>
              <li>Monitor and analyze trends and usage</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>3. Information Sharing</h2>
            <p>We do not sell, trade, or rent your personal information to third parties. We may share information:</p>
            <ul>
              <li>With your consent</li>
              <li>To comply with legal obligations</li>
              <li>To protect the rights and safety of our users</li>
              <li>With service providers who assist in operating our services</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>4. Data Security</h2>
            <p>We implement appropriate technical and organizational measures to protect your personal information. However, no method of transmission over the Internet is 100% secure.</p>
          </section>

          <section className={styles.section}>
            <h2>5. Cookies and Tracking</h2>
            <p>We use cookies and similar technologies to enhance your experience, analyze usage, and assist in our marketing efforts.</p>
          </section>

          <section className={styles.section}>
            <h2>6. Your Rights</h2>
            <p>Depending on your location, you may have rights to:</p>
            <ul>
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Delete your information</li>
              <li>Object to or restrict processing</li>
              <li>Data portability</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>7. Contact Us</h2>
            <p>If you have questions about this Privacy Policy, please contact us at:</p>
            <p className={styles.contact}>
              Email: support@onserv.com<br />
              Address:  ONSERV 30 N Gould St Ste 6087 Sheridan, WY 82801 USA
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;